import { $t } from "@/lib/helpers/i18nHelper";
import { Location } from "vue-router";
import config from "@/config";

export interface MenuItem {
  name: string;
  text: string;
  ref?: string;
  class?: string;
  href?: string;
  target?: string;
  click?: () => any;
  hide?: number;
  to?: Location;
}

export const menuItems: MenuItem[] = [
  {
    name: "manageProfile",
    text: $t("Login as user"),
    class: "mr-4",
    ref: "manageProfile",
    target: "_blank",
  },
  {
    name: "changePassword",
    text: $t("Change password"),
    ref: "changePassword",
    class: "mr-4",
    hide: 400,
  },
  {
    name: "disable",
    text: $t("Disable"),
    class: "mr-4",
    ref: "disable",
    hide: Number.POSITIVE_INFINITY,
  },
  {
    name: "delete",
    text: $t("Delete"),
    class: "mr-4",
    hide: Number.POSITIVE_INFINITY,
    ref: "delete",
  },
];
